(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('ComplainOnSms', ComplainOnSms);

    ComplainOnSms.$inject = ['$resource', 'DateUtils'];

    function ComplainOnSms ($resource, DateUtils) {
        var resourceUrl =  'api/complain-on-sms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.complainTime = DateUtils.convertDateTimeFromServer(data.complainTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
